// TraitementCongesManager.jsx — STYLE tc* appliqué + Redux backend

import React, { useEffect, useMemo, useState } from "react";
import "../TraitementStyles/TraitementCongesManager.css";
import { useDispatch, useSelector } from "react-redux";

import {
    getManagerInboxRequest,
    managerDecisionRequest,
    clearLeaveRequestMessage,
} from "../../../../redux/actions/leaveRequestsActions";

const TraitementCongesManager = () => {
    const dispatch = useDispatch();

    const leaveState = useSelector((state) => state.leaveRequests || {});
    const loading = !!leaveState.loading;
    const apiError = leaveState.error;
    const inbox = leaveState.managerInbox || [];
    const history = leaveState.managerHistory || [];

    const [selectedDemande, setSelectedDemande] = useState(null);
    const [decisionComment, setDecisionComment] = useState("");
    const [filterStatus, setFilterStatus] = useState("toutes");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        dispatch(getManagerInboxRequest());
        dispatch({ type: "GET_MANAGER_HISTORY_REQUEST" }); // Suppose it exists or is added
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const mapStatusToUi = (s) => {
        const v = String(s || "").toUpperCase();
        if (v === "PENDING_MANAGER") return "enCours";
        if (v === "APPROVED") return "approuve";
        if (v === "REJECTED") return "refuse";
        if (v === "POSTPONED") return "reporte";
        if (v === "CANCELLED") return "annule";
        return "enCours";
    };

    const demandes = useMemo(() => {
        const combined = [...inbox, ...history];
        return combined.map((d) => ({
            id: d.id,
            matricule: d.employeeCode || "—",
            nom: d.employeeName || "—",
            prenom: "",
            typeConge: d.absenceTypeNom || "—",
            dateDebut: d.dateDebut,
            dateFin: d.dateFin,
            duree: d.duree ?? 0,
            motif: d.commentaire || "—",
            justificatif: "—",
            statut: mapStatusToUi(d.status),
        }));
    }, [inbox, history]);

    const demandesFiltrees = useMemo(() => {
        return demandes.filter((d) => {
            const matchStatus = filterStatus === "toutes" ? true : d.statut === filterStatus;
            const term = searchTerm.trim().toLowerCase();
            const matchSearch =
                !term || `${d.matricule} ${d.nom} ${d.prenom} ${d.typeConge}`.toLowerCase().includes(term);
            return matchStatus && matchSearch;
        });
    }, [demandes, filterStatus, searchTerm]);

    const safeErrorText = (err) => {
        if (!err) return "";
        if (typeof err === "string") return err;
        if (err?.message) return String(err.message);
        try {
            return JSON.stringify(err);
        } catch {
            return String(err);
        }
    };

    console.log("demandesFiltrees",demandesFiltrees)
    const closeModal = () => {
        setSelectedDemande(null);
        setDecisionComment("");
    };

    const handleApprove = () => {
        if (!selectedDemande) return;
        dispatch(
            managerDecisionRequest({
                id: selectedDemande.id,
                approved: true,
                comment: decisionComment || "",
            })
        );
        closeModal();
        dispatch(clearLeaveRequestMessage());
    };

    const handleReject = () => {
        if (!selectedDemande) return;
        dispatch(
            managerDecisionRequest({
                id: selectedDemande.id,
                approved: false,
                comment: decisionComment || "",
            })
        );
        closeModal();
        dispatch(clearLeaveRequestMessage());
    };

    const statusLabel = (s) => (s === "enCours" ? "En attente" : s === "approuve" ? "Approuvée" : s === "refuse" ? "Refusée" : s === "reporte" ? "Reportée" : "Annulée");

    const statusStyle = (s) => {
        if (s === "enCours") return { background: "rgba(238,100,95,.12)", color: "#ee645f" };
        if (s === "approuve") return { background: "rgba(16,185,129,.12)", color: "#10b981" };
        if (s === "reporte") return { background: "rgba(37,99,235,.12)", color: "#2563eb" };
        if (s === "annule") return { background: "rgba(107,114,128,.12)", color: "#4b5563" };
        return { background: "rgba(239,68,68,.12)", color: "#ef4444" };
    };

    return (
        <div className="tcPage">
            <div className="tcWrap">
                <div className="tcHeader">
                    <h1>Traitement des Demandes de Congés </h1>
                </div>

                <div className="tcCard">
                    <div className="tcFilters" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
                        <div className="tcField">
                            <label>Statut</label>
                            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                                <option value="toutes">Toutes</option>
                                <option value="enCours">En attente</option>
                                <option value="approuve">Approuvées</option>
                                <option value="refuse">Refusées</option>
                                <option value="reporte">Reportées</option>
                                <option value="annule">Annulées</option>
                            </select>
                        </div>

                        <div className="tcField">
                            <label>Recherche</label>
                            <input
                                type="text"
                                placeholder="Matricule, nom, type..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    {apiError && (
                        <div style={{ marginTop: 10, color: "#ef4444", fontSize: 12 }}>
                            {safeErrorText(apiError)}
                        </div>
                    )}

                    <div className="tcTableWrap" style={{ marginTop: 12 }}>
                        <table className="tcTable">
                            <thead>
                            <tr>
                                <th>Matricule</th>
                                <th>Nom</th>
                                <th>Type</th>
                                <th>Période</th>
                                <th className="is-right">Durée</th>
                                <th>Motif</th>
                                <th>Justificatif</th>
                                <th>Statut</th>
                                <th className="is-right">Action</th>
                            </tr>
                            </thead>

                            <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: 18 }}>
                                        Chargement...
                                    </td>
                                </tr>
                            ) : demandesFiltrees.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: 18 }}>
                                        Aucune demande
                                    </td>
                                </tr>
                            ) : (
                                demandesFiltrees.map((demande) => (
                                    <tr key={demande.id}>
                                        <td className="tcPrimary">{demande.matricule}</td>
                                        <td>
                                            <div className="tcName">
                          <span className="tcPrimary">
                            <span className="tcPrimary">{demande.nom} {demande.prenom}</span>                          </span>
                                            </div>
                                        </td>
                                        <td>{demande.typeConge}</td>
                                        <td>
                                            <div className="tcPeriod">
                                                <span className="tcMuted">{demande.dateDebut} → {demande.dateFin}</span>
                                            </div>
                                        </td>
                                        <td className="is-right">{demande.duree} j</td>
                                        <td>{demande.motif}</td>
                                        <td className="tcMuted">{demande.justificatif}</td>
                                        <td>
                        <span className="tcBadge" style={statusStyle(demande.statut)}>
                          {statusLabel(demande.statut)}
                        </span>
                                        </td>
                                        <td className="is-right">
                                            {demande.statut === "enCours" ? (
                                                <button
                                                    className="tcBtn tcBtn--ghost"
                                                    onClick={() => setSelectedDemande(demande)}
                                                    style={{ padding: "7px 10px" }}
                                                >
                                                    Traiter
                                                </button>
                                            ) : (
                                                <span className="tcMuted">—</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {selectedDemande && (
                    <div className="tcModal" onMouseDown={(e) => e.target === e.currentTarget && closeModal()}>
                        <div className="tcModal__panel" role="dialog" aria-modal="true">
                            <div className="tcModal__header">
                                <div className="tcModal__headLeft">
                                    <div className="tcModal__icon">!</div>
                                    <div>
                                        <div className="tcModal__title">Décision Manager</div>
                                        <div className="tcModal__sub">
                                            {selectedDemande.nom} {selectedDemande.prenom} ({selectedDemande.matricule})
                                        </div>
                                    </div>
                                </div>

                                <button className="tcIconBtn" onClick={closeModal} aria-label="Fermer">
                                    ✕
                                </button>
                            </div>

                            <div className="tcModal__body">
                                <div style={{ marginBottom: 10, fontSize: 13 }}>
                                    <div>
                                        <span className="tcPrimary">Type :</span>{" "}
                                        <span className="tcMuted">{selectedDemande.typeConge}</span>
                                    </div>
                                    <div style={{ marginTop: 6 }}>
                                        <span className="tcPrimary">Période :</span>{" "}
                                        <span className="tcMuted">
                      {selectedDemande.dateDebut} → {selectedDemande.dateFin} ({selectedDemande.duree} j)
                    </span>
                                    </div>
                                </div>

                                <label className="tcLabel">
                                    Commentaire <span className="tcMuted">(optionnel)</span>
                                </label>
                                <textarea
                                    className="tcTextarea"
                                    rows={4}
                                    placeholder="Ajouter un commentaire..."
                                    value={decisionComment}
                                    onChange={(e) => setDecisionComment(e.target.value)}
                                />
                                <div className="tcHelp">Ce commentaire sera enregistré avec la décision.</div>
                            </div>

                            <div className="tcModal__footer">
                                <button className="tcBtn tcBtn--ghost" onClick={closeModal}>
                                    Annuler
                                </button>
                                <button className="tcBtn tcBtn--ghost" onClick={handleApprove}>
                                    Approuver
                                </button>
                                <button className="tcBtn tcBtn--danger" onClick={handleReject}>
                                    Refuser
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TraitementCongesManager;
